
import { Injectable} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DatePipe } from '@angular/common';


@Injectable({ providedIn: 'root' })
export class ValidationMessageService {
  private readonly validationMessagesNodeName: string = 'ValidationMessages';

  constructor(private translate: TranslateService,private datePipe : DatePipe) {
  }

  public getValidatorErrorMessage(validatorName: string, validatorValue?: any) {
    const messageProp = `${this.validationMessagesNodeName}.${validatorName}`
    switch (validatorName)
    {
      case ("minlength"):
      case ("maxlength"):
        return this.translate.instant(messageProp, { length: validatorValue.requiredLength });
      case ("pattern"):
        return this.getPatternErrorMessages(validatorName, validatorValue);
      case ("bsDate"):
        return this.getMinMaxDateMessages(validatorValue);
      case ("externalValidation"):
        return validatorValue;
      case ("minValue"):
        return this.translate.instant(`${this.validationMessagesNodeName}.minValue`, { value: validatorValue });
      case ("maxValue"):
        return this.translate.instant(`${this.validationMessagesNodeName}.maxValue`, { value: validatorValue });
      case ("minPercentage"):
      case ("maxPercentage"):
      case ("maxCurrency"):
      case ("minCurrency"):
        return this.translate.instant(messageProp, { value: validatorValue });
      case ("exactLength"):
        return this.translate.instant(messageProp, { length: validatorValue });
      default:
        return this.translate.instant(messageProp);
    }
  }

  getPatternErrorMessages(validatorName: string, validatorValue?: any) {

    switch (validatorValue.requiredPattern) {
      case (String.raw`^\d*$`):
        return this.translate.instant(`${this.validationMessagesNodeName}.numericalInput`);
      case (String.raw`^(PT|pt|Pt|pT)50.*$`):
        return this.translate.instant(`${this.validationMessagesNodeName}.nationalIban`);
      case (String.raw`^.+@.+\..+$`):
        return this.translate.instant(`${this.validationMessagesNodeName}.email`);
      case (this.translate.instant(`${ this.validationMessagesNodeName }.landLineNumberRegExp`)):
        return this.translate.instant(`${this.validationMessagesNodeName}.landLineNumberMsg`);
      case (this.translate.instant(`${this.validationMessagesNodeName}.mobileNumberRegExp`)):
        return this.translate.instant(`${this.validationMessagesNodeName}.mobileNumberMsg`);
      case (this.translate.instant(`${this.validationMessagesNodeName}.internationalNumberRegExp`)):
        return this.translate.instant(`${this.validationMessagesNodeName}.internationalNumberMsg`);
      default:
        return this.translate.instant(`${this.validationMessagesNodeName}.${validatorName}`);
    }
  }

  getMinMaxDateMessages(validatorValue?: any) {    
    if (validatorValue.minDate)
      return this.translate.instant(`${this.validationMessagesNodeName}.minimumDate`, { date: this.datePipe.transform(validatorValue.minDate,'yyyy-MM-dd')});
    else if (validatorValue.maxDate)
      return this.translate.instant(`${this.validationMessagesNodeName}.maximumDate`, { date: this.datePipe.transform(validatorValue.maxDate, 'yyyy-MM-dd') });
    else
      return null;
  }
}
